export default {
  idleTime: 4 * 60 * 1000,
  updateTime: 30 * 1000,
  timezone: 'America/Sao_Paulo',
  language: 'pt-BR',
  yearStart: 2018,
};
